<template>
  <CModal v-if="berthId"
          title="Add Berth Commodity"
          color="success"
          :show="show"
          :centered="true"
          @update:show="$emit('update:show', false)">

    <div class="content">
      <div class="modal-title">
        <h2 class="">Commodity Details</h2>
        <i v-if="loading" class="fa fa-cog fa-spin fa-2x"></i>
      </div>

      <template v-if="errors.length">
        <CAlert v-for="(error, index) in errors" :key="`error-${index}`" color="danger" closeButton>
          {{ error }}
        </CAlert>
      </template>

      <CRow>
        <CCol col="12">
          <CForm @submit="handleAddBerthCommodity">

            <treeselect-custom v-model="fields.commodity.value"
                               :choices="fields.commodity.items" />

            <CSelect label="Direction"
                     :value.sync="fields.direction.value"
                     :options="fields.direction.items"
                     placeholder="Please select"
                     horizontal />
          </CForm>
        </CCol>
      </CRow>
    </div>

    <template #footer>
      <CButton @click="handleCancel" color="secondary">
        Cancel
      </CButton>
      <CButton @click="handleAddBerthCommodity" :disabled="!isDataValid" color="success">
        Add
      </CButton>
    </template>

  </CModal>
</template>

<script>
import groupBy from 'lodash-es/groupBy'
import getNested from 'lodash-es/get'
import { mapActions } from 'vuex'
import TreeselectCustom from '../../widgets/TreeselectCustom'


export default {
  name: 'berth-commodity-add-modal',

  components: {
    TreeselectCustom
  },

  props: {
    berthId: {
      type: Number,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,

      fields: {
        direction: {
          value: null,
          items: [
            {value: 'IMPORT', label: 'Import'},
            {value: 'EXPORT', label: 'Export'},
          ],
        },

        commodity: {
          value: null,
          items: [],
        },
      },

      errors: [],
    };
  },

  async mounted() {
    await this.loadCommodities();
  },

  methods: {
    ...mapActions(
      'polygons', [
        'listCommodities',
        'addBerthCommodity',
      ],
    ),

    async loadCommodities() {
      let commodities = await this.listCommodities();
      commodities = groupBy(commodities, 'group') || [];

      this.fields.commodity.items = Object.keys(commodities).map(
        groupName => {
          // allow to select commodity items
          let groupItems = commodities[groupName].map(
            item => ({id: item.value, label: item.text})
          );

          return {
            id: groupName,
            label: groupName,
            children: groupItems
          };
        }
      );
    },

    handleCancel() {
      this.$emit('update:show', false);
    },

    async handleAddBerthCommodity(evt) {
      if(evt) {
        evt.preventDefault();
      }
      if(!this.isDataValid) {
        return;
      }

      this.loading = true;
      this.errors = [];
      let result = await this.addBerthCommodity({
        berthId: this.berthId,
        commodityId: this.fields.commodity.value.id,
        flowDirection: this.fields.direction.value,
      });

      if(result.error) {
        if(result.error_details.message.includes('already exists')) {
          this.errors.push('This commodity already exists');
        } else {
          this.errors.push('Unknown error');
        }
      } else {
        this.$emit('updated', result);
        this.$emit('update:show', false);
      }
      this.loading = false;
    },

  },

  computed: {
    isDataValid() {
      return (
        getNested(this, 'fields.commodity.value.id') &&
        getNested(this, 'fields.direction.value')
      );
    }
  },
}
</script>

<style scoped>

</style>

<style scoped lang="scss">
  .modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .fa-cog {
      color: #adadad;
    }
  }
</style>
